import React from 'react';
import { formatNumber, formatMoney } from 'accounting-js';

const Portlet = ({
  children,
  icon,
  title,
  subtitle,
  button = null,
  buttonTwo = null,
  filter = null,
  count = null,
  totalMoney = null
}) => {
  let total = totalMoney
  let totalDocs = formatNumber(count)
  let arraydocs = totalDocs.split(".")
  totalDocs = arraydocs[0]

  return (
    <div className="portlet light bordered" style={{ position: 'relative' }}>
      {title && (
        <div className="portlet-title">
          <div className="caption font-green d-flex justify-content-between">
            <div className={`d-flex flex-row align-items-center`}>
              {icon && <i className={`fa fa-${icon} mr-3`} />}
              <span className={`caption-subject bold uppercase mr-3`}>
                {title}{' '}
                {subtitle && (
                  <small>
                    {' - '}
                    {subtitle}
                  </small>
                )}
              </span>
              <div>{filter}</div>
            </div>
            <div className="d-flex flex-row justify-content-end w-50">
              {button ? button : null}
              {buttonTwo ? buttonTwo : null}
            </div>
          </div>
          <div>{count ? <p>Registros: {totalDocs}</p> : null } {total ? <p> Total: {formatMoney(total)} </p> : null} </div>
        </div>
      )}
      {children}
    </div>
  );
};

export default Portlet;



// WEBPACK FOOTER //
// src/modules/common/components/Portlet.js